// Globals
import { useTranslation } from 'react-i18next';

// Permissions
import { Resource, usePermissions } from '@/modules/Permissions';

// Components
import { Pagination } from '@/components';
import { Table } from '@/ui';
import MetaTagsFiltersContainer from '../../containers/MetaTagsFiltersContainer/MetaTagsFiltersContainer';
import { StyledWrapper } from '../Styled';

// Models
import { IMetaTag } from '@/models/metaTags.model';

// Helpers
import { getMetaTagsTableColumns } from './columns';

type TMetaTagsListProps = {
  list: IMetaTag[];
  isLoading: boolean;
  currentPage: number;
  total: number;
  onPageChange: (page: number) => void;
  onEdit: (item: IMetaTag) => void;
  onDelete: (item: IMetaTag) => void;
};

const MetaTagsList = ({ isLoading, list, total, currentPage, onPageChange, onEdit, onDelete }: TMetaTagsListProps) => {
  const { t } = useTranslation(['metatags']);
  const { canManage } = usePermissions();

  return (
    <StyledWrapper>
      <Table
        columns={getMetaTagsTableColumns({ t, onDelete, onEdit, canManage: canManage(Resource.SEO) })}
        loading={isLoading}
        dataSource={list}
        rowKey="id"
        scroll={{ x: 'max-content' }}
        components={{
          header: {
            wrapper: MetaTagsFiltersContainer,
          },
        }}
      />
      <Pagination hideOnSinglePage current={currentPage} total={total} onChange={onPageChange} />
    </StyledWrapper>
  );
};

export default MetaTagsList;
